import React from 'react';
const steps = [{
  num: 1,
  text: 'Accedés al material'
}, {
  num: 2,
  text: 'Revisás el contenido'
}, {
  num: 3,
  text: 'Lo aplicás en tu trabajo real'
}];
export function Guarantee() {
  return <section className="bg-white py-16 px-5" data-id="element-153">
      <div className="max-w-xl mx-auto" data-id="element-154">
        <div className="bg-slate-50 border border-slate-100 rounded-3xl p-8 md:p-12 shadow-sm" data-id="element-155">
          <h2 className="text-2xl md:text-3xl font-black text-slate-900 text-center mb-10" data-id="element-156">
            🛡️ Garantía 7 días sin preguntas
          </h2>

          <div className="space-y-4 mb-10" data-id="element-157">
            {steps.map(step => <div key={step.num} className="flex items-center gap-6 bg-white border border-slate-100 rounded-2xl px-6 py-4 shadow-sm" data-id="element-158">
                <div className="bg-[#C8A96B] text-white text-sm font-black w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-159">
                  {step.num}
                </div>
                <span className="text-base font-bold text-slate-700" data-id="element-160">
                  {step.text}
                </span>
              </div>)}
          </div>

          <div className="bg-green-50 border border-green-100 rounded-2xl p-8 text-center" data-id="element-161">
            <p className="text-sm text-slate-500 mb-3 font-medium" data-id="element-162">
              Si en 7 días no es lo que esperabas:
            </p>
            <p className="md:text-3xl font-black text-green-600 mb-2 text-[16px]" data-id="element-163">
              👉 Te devolvemos el 100%
            </p>
            <p className="text-xs text-slate-400 font-bold uppercase tracking-widest" data-id="element-164">
              Sin preguntas. Sin vueltas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}